import React from "react";
import { Outlet } from "react-router-dom";

const OnboardingRoute = () => {
  // BYPASS AUTH: No authentication checks, no localStorage checks, always allow access
  return <Outlet />;
};

export default OnboardingRoute;